import { useState } from "react";
import { SidebarData } from "./ComponentsData/SidebarData";
import AccountIcon from "../assets/images/UserIcon.svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

let navExpanded = false;

function Sidebar() {
  let navigate = useNavigate();
  let auth = useAuth();
  const [expanded, setExpanded] = useState(navExpanded);

  const toggleExpanded = () => {
    setExpanded((prev) => {
      const next = !prev;
      navExpanded = next;
      document.querySelectorAll(".staticElement").forEach((el) => {
        el.classList.toggle("expanded", next);
      });
      return next;
    });
  };

  return (
    <div className={`navPanel${expanded ? " expanded" : ""}`}>
      <button
        type="button"
        className="navToggle"
        onClick={toggleExpanded}
        aria-label={expanded ? "Collapse menu" : "Expand menu"}
      >
        <span
          className={`navToggle-arrow${expanded ? " navToggle-arrow--left" : ""}`}
        ></span>
      </button>
      <div className="navFixing">
        <div className="navUser">
          <img src={AccountIcon} alt="account" />
          <p>
            {auth.isAuthenticated &&
              String.prototype.concat(
                "  Hi, ",
                auth.user?.profile?.FirstName,
                "!",
              )}
          </p>
        </div>
        <ul className="navPanelList">
          {SidebarData.map((val, key) => {
            const hasRole = (users) =>
              users.filter((x) => auth.user?.profile?.role.includes(x)).length > 0;

            const canOpenSection = hasRole(val.users);
            const allowedSubSections = (val.subSections ?? []).filter((e) => hasRole(e.users));

            if (!canOpenSection && allowedSubSections.length === 0)
              return null;

            const sectionLink = canOpenSection ? val.link : allowedSubSections[0].link;

            let isActive = window.location.pathname === val.link;
            val.subSections?.forEach((e) => {
              if (e.link === window.location.pathname) isActive = true;
            });

            return (
              <li key={key} className="navTabs" id={isActive ? "active" : ""}>
                <div className="nav__mainSection">
                  <div className="navFlag"></div>
                  <div
                    className="navIcons"
                    id={
                      window.location.pathname === val.link ? "active-icon" : ""
                    }
                    onClick={() => {
                      navigate(sectionLink);
                    }}
                  >
                    {val.icon}
                  </div>
                  <div
                    className="navTitle"
                    id={
                      window.location.pathname === val.link
                        ? "active-section"
                        : ""
                    }
                    onClick={() => {
                      navigate(sectionLink);
                    }}
                  >
                    {val.title}
                  </div>
                </div>

                {allowedSubSections.map((subVal, subKey) => {
                    const isSubActive =
                      window.location.pathname === subVal.link;

                    return (
                      <div
                        key={subKey}
                        className="nav__subSections"
                        id={isSubActive ? "active-section" : ""}
                        title={subVal.title}
                        onClick={() => {
                          navigate(subVal.link);
                        }}
                      >
                        <div
                          className="navIcons__subItem"
                          id={isSubActive ? "active-icon" : ""}
                        >
                          {subVal.icon}
                        </div>
                        <p>{subVal.title}</p>
                      </div>
                    );
                  })}
              </li>
            );
          })}
        </ul>
        <div className="LOGO" />
      </div>
    </div>
  );
}

export default Sidebar;
